import { render, staticRenderFns } from "./TailwindSlideOver.vue?vue&type=template&id=a080a66a&"
import script from "./TailwindSlideOver.vue?vue&type=script&lang=js&"
export * from "./TailwindSlideOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports